<!-- Replaces fieldInstanceDirective.js -->
<template>
    <span data-component="FieldInstance"
          class="field-value">{{ displayValue }}</span>
</template>

<script>
import FieldType from '@/lib/CustomFields/FieldType';
import { calculateAgeFromDob } from '@/functions/age';

export default {
    name: 'FieldInstance',

    props: {
        instance: {
            type: Object,
            required: true,
        },
    },

    computed: {
        displayValue() {
            if (this.instance.field.type === FieldType.DOB) {
                // Not in edit mode. Calculate the age for a date of birth field but don't show any errors.
                if (this.instance.value) {
                    try {
                        // Todo: refactor this and FieldInstance.js so we can avoid side effects.
                        // https://digitickets.atlassian.net/browse/PROP-2860
                        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                        this.instance.age = calculateAgeFromDob(this.instance.value);
                    } catch (e) {
                    }
                }
            }
            return this.instance.getDisplayValue(true);
        },
    },
};
</script>
